<template>
  <div>
    <p
      v-if="isMixedTemplatesDesignsSelected"
      class="alert alert-danger"
    >
      You must select exclusively from the new or legacy template groups.
    </p>
    <b-row
      align-v="stretch"
      v-if="hasNewDesignTemplates"
      :class="{ 'mb-5': !hasLegacyDesignTemplates }"
    >
      <b-col
        v-for="(template, index) in newDesignTemplatesList"
        :key="index"
        lg="4"
      >
        <div
          :class="{'card-active': isTemplateSelected(template.id), 'card-disabled': isLastSelectedTemplate(template.id)}"
          @click="updateSelectedTemplate(template.id)"
          class="template-card h-100 d-flex"
        >
          <i
            class="fas fa-check-circle isActiveBox text-success"
            v-if="isTemplateSelected(template.id)"
          />
          <span
            class="self-service-template-label blue"
          >
            New Design
          </span>
          <div
            :data-test="`template-${ template.id }`"
            class="card-body align-items-center d-flex justify-content-center"
          >
            <div class="text-center">
              <div class="m-0">
                <img :src="getCreativeSvg(template)">
              </div>
              <div class="mt-3">
                {{ template.name }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="read-only-overlay"
          v-if="GET_IS_READ_ONLY('creative-properties')"
        />
      </b-col>
    </b-row>
    <div
      v-if="hasNewDesignTemplates && hasLegacyDesignTemplates"
      class="d-block templates-divider my-3"
    />
    <b-row
      v-if="hasLegacyDesignTemplates"
      align-v="stretch"
    >
      <b-col
        v-for="(template, index) in legacyDesignTemplatesList"
        :key="index"
        class="mb-5"
        lg="4"
      >
        <div
          :class="{'card-active': isTemplateSelected(template.id), 'card-disabled': isLastSelectedTemplate(template.id)}"
          @click="updateSelectedTemplate(template.id)"
          class="template-card h-100 d-flex"
        >
          <i
            class="fas fa-check-circle isActiveBox text-success"
            v-if="isTemplateSelected(template.id)"
          />
          <span
            v-if="hasNewDesignTemplates"
            class="self-service-template-label grey"
          >
            Legacy
          </span>
          <div
            :data-test="`template-${ template.id }`"
            class="card-body align-items-center d-flex justify-content-center"
          >
            <div class="text-center">
              <div class="m-0">
                <img :src="getCreativeSvg(template)">
              </div>
              <div class="mt-3">
                {{ template.name }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="read-only-overlay"
          v-if="GET_IS_READ_ONLY('creative-properties')"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as templatesTypes from '@/modules/templates/store/types';

export default {
  name: 'SelfServiceTemplateSelection',
  data() {
    return {

    };
  },
  computed: {
    ...mapState('templates', [
      'availableTemplates',
      'selectedTemplates',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_READ_ONLY,
    ]),
    newDesignTemplatesList() {
      return this.availableTemplates
        .filter((template) => this.isANewDesignTemplate(template.id));
    },
    legacyDesignTemplatesList() {
      return this.availableTemplates
        .filter((template) => !this.isANewDesignTemplate(template.id));
    },
    hasNewDesignTemplates() {
      return this.newDesignTemplatesList.length > 0;
    },
    hasLegacyDesignTemplates() {
      return this.legacyDesignTemplatesList.length > 0;
    },
    isLegacyDesignSelected() {
      return this.selectedTemplates.filter((templateId) => !this.isANewDesignTemplate(templateId)).length > 0;
    },
    isNewDesignSelected() {
      return this.selectedTemplates.filter((templateId) => this.isANewDesignTemplate(templateId)).length > 0;
    },
    isMixedTemplatesDesignsSelected() {
      return this.isLegacyDesignSelected && this.isNewDesignSelected;
    },
  },
  methods: {
    ...mapActions('templates', [
      templatesTypes.UPDATE_SELECTED_TEMPLATES,
    ]),
    isTemplateSelected(id) {
      return this.selectedTemplates.includes(id);
    },
    isLastSelectedTemplate(id) {
      return this.selectedTemplates.length === 1 && this.selectedTemplates.includes(id);
    },
    updateSelectedTemplate(id) {
      if (this.isLastSelectedTemplate(id)) return;
      this.UPDATE_SELECTED_TEMPLATES({
        id,
        isChecked: this.isTemplateSelected(id),
      });
      this.updateIsValidTemplateSelection();
      this.$emit('templateSelectionChanged');
    },
    isANewDesignTemplate(templateId) {
      return process.env.VUE_APP_NEW_DESIGN_TEMPLATE_IDS.includes(templateId);
    },
    getCreativeSvg(template) {
      const creativeWidth = `${template.width}`.replaceAll('0', 'O');
      const creativeHeight = `${template.height}`.replaceAll('0', 'O');
      // eslint-disable-next-line import/no-dynamic-require, global-require
      return require(`@/assets/creatives/${creativeWidth}x${creativeHeight}.svg`);
    },
    updateIsValidTemplateSelection() {
      this.$emit('isValidSelfServiceTemplateSelection', (this.selectedTemplates.length > 0 && !this.isMixedTemplatesDesignsSelected));
    },
  },
  watch: {
    selectedTemplates() {
      this.updateIsValidTemplateSelection();
    },
  },
};
</script>
<style lang="scss" scoped>
.template-card {
  position: relative;
  background: #dfe0e6;
  cursor: pointer;
  border: 1px solid rgba(0, 40, 100, 0.12);
  border-radius: 0.25rem;
  .self-service-template-label {
    position: absolute;
    color: white;
    top: 5px;
    right: 5px;
    margin-bottom: 0px;
    padding: 2px 6px;
    border-radius: 0.25rem;
    z-index: 1;
    &.blue {
      background-color: #45AAF2;
    }
    &.grey {
      background-color: #6C757D;
    }
  }
}
.isActiveBox {
  position: absolute;
  top: .25rem;
  left: .25rem;
  z-index: 1;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  border-radius: 3px;
  transition: .3s opacity;
}
.read-only-overlay {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: not-allowed;
  z-index: 1;
}
.card-disabled {
  cursor: no-drop;
}
.templates-divider {
  border-bottom: 1px solid #0028641F;
}
</style>
